import api from './api';

// class with functions for service api calls
class ReportService {

  //get list of preport data 
  getReports() {
    return api.get('reports/list');
  }

  //delete repor
  deleteReport(report) {
    return api.delete('reports/delete/' + report);
  }


  //create a new report 
  createNewReport(newReport) {
    return api.post('Reports/create', newReport);
  }
}

export default new ReportService();
